<template lang="pug">
#empresa-bloco-inserir-contrato-originacao-manualmente
    el-card(:body-style='{ padding: "20px" }', shadow='never')
        el-form.col-12(
            label-position='top',
            :model='formCadastroManual',
            :rules='formCadastroManualRegras',
            ref='formCadastroManualRef'
        )
            .row
                el-form-item.col-3(
                    label='Número do contrato',
                    prop='numeroContrato'
                )
                    el-input#numeroContrato(
                        v-model.number='formCadastroManual.numeroContrato',
                        placeholder='40010000',
                        maxlength='8'
                    )

                el-form-item.col-2(label='Cultura', prop='cultura')
                    el-select#cultura(
                        v-model='formCadastroManual.cultura',
                        :loading='loading.culturas',
                        clearable,
                        filterable
                    )
                        el-option(
                            v-for='({ nome, id }, index) in opcoes.culturas',
                            :key='id + nome',
                            :id='"cultura-" + index',
                            :label='nome',
                            :value='id'
                        )

                el-form-item.col-1(label='Safra', prop='safra')
                    el-select#safra(
                        v-model='formCadastroManual.safra',
                        :loading='loading.safras',
                        clearable,
                        filterable
                    )
                        el-option(
                            v-for='({ ano, id }, index) in opcoes.safras',
                            :key='id + ano',
                            :id='"safra-" + index',
                            :label='ano',
                            :value='id'
                        )

                el-form-item.col-3(
                    label='Volume vendido (t)',
                    prop='volumeContratado'
                )
                    el-input#volumeContratado(
                        v-model='formCadastroManual.volumeContratado'
                    )

                el-form-item.col-3(
                    label='Data do contrato',
                    prop='dataContrato'
                )
                    el-date-picker#dataContrato(
                        v-model='formCadastroManual.dataContrato',
                        type='date',
                        placeholder='Selecione',
                        format='dd/MM/yyyy',
                        :picker-options='pickerOptionsDataContrato'
                    )

            .row
                el-form-item.col-1(label='UF entrega', prop='estado')
                    el-select#estado(
                        v-model='formCadastroManual.estado',
                        :loading='loading.estados',
                        @change='buscarLocalidadeNivelDois',
                        @clear='buscarLocalidadeNivelDois',
                        :placeholder='$t("mensagens.comuns.selecione")',
                        clearable,
                        filterable
                    )
                        el-option(
                            v-for='{ sigla, id } in opcoes.estados',
                            :key='id + sigla',
                            :id='"estado-" + sigla',
                            :label='sigla',
                            :value='id'
                        )

                el-form-item.col-2(label='Município entrega', prop='municipio')
                    el-select#municipio(
                        v-model='formCadastroManual.municipio',
                        :loading='loading.municipios',
                        :disabled='!formCadastroManual.estado',
                        :placeholder='$t("mensagens.comuns.selecione")',
                        clearable,
                        filterable
                    )
                        el-option(
                            v-for='{ nome, id } in opcoes.municipios',
                            :key='id + nome',
                            :id='"municipio-" + id',
                            :label='nome',
                            :value='id'
                        )

                el-form-item.col-3(label='Filial', prop='fornecedor')
                    el-select#fornecedor(
                        v-model='formCadastroManual.fornecedor',
                        value-key='id',
                        :loading='loading.fornecedor',
                        @change='definirCnpjFornecedor',
                        clearable,
                        filterable
                    )
                        el-option(
                            v-for='fornecedor in opcoes.fornecedores',
                            :key='fornecedor.id + fornecedor.nome',
                            :id='"filial-" + fornecedor.id',
                            :label='fornecedor.nome',
                            :value='fornecedor'
                        )
                el-form-item.col-3(label='Cliente', prop='cliente')
                    el-select#cliente(
                        v-model='formCadastroManual.cliente',
                        value-key='id',
                        :loading='loading.clientes',
                        @change='definirClienteDocumento',
                        @clear='definirClienteDocumento',
                        clearable,
                        filterable
                    )
                        el-option(
                            v-for='cliente in opcoes.clientes',
                            :key='cliente.id + cliente.nomeRazaoSocial',
                            :id='"cliente-" + cliente.id',
                            :label='cliente.nomeRazaoSocial',
                            :value='cliente'
                        )

                el-form-item.col-3(
                    label='CNPJ cliente',
                    prop='clienteDocumento'
                )
                    el-select#clienteDocumento(
                        v-model='formCadastroManual.clienteDocumento',
                        :disabled='!formCadastroManual.cliente',
                        placeholder='Selecione o CNPJ do cliente',
                        clearable,
                        filterable
                    )
                        el-option(
                            v-for='(documento, index) in formCadastroManual.cliente?.clienteDocumentos',
                            :key='documento.id',
                            :id='"clienteDocumento-" + index',
                            :label='documento.cpfCnpj',
                            :value='documento.id'
                        )
            .row.row-btn-adicionar
                el-form-item.col-3(
                    label='Número do contrato cliente',
                    prop='codigoExterno'
                )
                    el-input#numeroContrato(
                        v-model='formCadastroManual.codigoExterno'
                    )

                el-form-item.col-3.botao
                    el-button#adicionar(
                        type='primary',
                        :disabled='adicionandoContrato',
                        @click='adicionar'
                    )
                        i.el-icon(
                            :class='adicionandoContrato ? "el-icon-loading" : "el-icon-plus"'
                        )
                        | Adicionar à lista
</template>

<script>
import ContratoOriginacaoService from '@/services/ContratoOriginacaoService';
import ContratoOriginacaoServiceEmpresa from '@/services/ContratoOriginacaoServiceEmpresa';
import LocalidadeService from '@/services/LocalidadeService';
import { mapGetters } from 'vuex';

export default {
    name: 'EmpresaBlocoInserirContratoOriginacaoManualmenteAlvorada',

    data() {
        const validarNumeroContrato = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('Campo obrigatório'));
                return;
            }

            if (value.toString().length !== 8) {
                callback(
                    new Error('O número do contrato deve conter 8 números')
                );
                return;
            }

            const apenasNumeros = /^\d*$/;
            if (!apenasNumeros.test(value)) {
                callback(
                    new Error('O número do contrato deve ser apenas números')
                );
                return;
            }

            if (value.toString().substr(0, 3) !== '400') {
                callback(
                    new Error('O número do contrato deve começar com "400"')
                );
                return;
            }

            callback();
        };

        const validarVolumeContratado = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('Campo obrigatório'));
                return;
            }

            if (value.toString().includes('.')) {
                callback(
                    new Error(
                        'Não pode haver pontos, somente virgulas e números'
                    )
                );
                return;
            }

            const maisVirgulas = /.*,.*,.*/;
            if (
                maisVirgulas.test(value) ||
                value.toString().startsWith(',') ||
                value.toString().endsWith(',')
            ) {
                callback(new Error('Número mal formatado'));
                return;
            }

            const numeroVirgula = /^[\d,]+$/;
            if (!numeroVirgula.test(value)) {
                callback(new Error('Valor não aceito'));
                return;
            }

            if (parseFloat(value.toString().replace(',', '.')) <= 0) {
                callback(new Error('Valor deve ser maior que zero'));
                return;
            }

            callback();
        };

        return {
            formCadastroManual: {
                numeroContrato: '',
                cultura: '',
                safra: '',
                volumeContratado: '',
                dataContrato: '',
                estado: '',
                municipio: '',
                fornecedor: null,
                cnpjFornecedor: '',
                cliente: '',
                clienteDocumento: null,
                codigoExterno: ''
            },

            formCadastroManualRegras: {
                numeroContrato: [
                    {
                        required: true,
                        validator: validarNumeroContrato,
                        trigger: 'change'
                    }
                ],
                cultura: [
                    {
                        required: true,
                        message: 'Campo obrigatório',
                        trigger: 'change'
                    }
                ],
                safra: [
                    {
                        required: true,
                        message: 'Campo obrigatório',
                        trigger: 'change'
                    }
                ],
                volumeContratado: [
                    {
                        required: true,
                        validator: validarVolumeContratado,
                        trigger: 'change'
                    }
                ],
                dataContrato: [
                    {
                        required: true,
                        message: 'Campo obrigatório',
                        trigger: 'change'
                    }
                ],
                estado: [
                    {
                        required: true,
                        message: 'Campo obrigatório',
                        trigger: 'change'
                    }
                ],
                municipio: [
                    {
                        required: true,
                        message: 'Campo obrigatório',
                        trigger: 'change'
                    }
                ],
                fornecedor: [
                    {
                        required: true,
                        message: 'Campo obrigatório',
                        trigger: 'change'
                    }
                ],
                cliente: [
                    {
                        required: true,
                        message: 'Campo obrigatório',
                        trigger: 'change'
                    }
                ],
                clienteDocumento: [
                    {
                        required: true,
                        message: 'Campo obrigatório',
                        trigger: 'change'
                    }
                ],
                codigoExterno: [
                    {
                        required: false,
                        trigger: 'change'
                    }
                ]
            },

            opcoes: {
                culturas: [],
                safras: [],
                fornecedores: [],
                estados: [],
                municipios: [],
                clientes: [],
                camposNaoAtribuidos: []
            },

            loading: {
                culturas: true,
                safras: true,
                fornecedor: true,
                cnpjFornecedores: true,
                estados: true,
                municipios: true,
                clientes: true
            },

            adicionandoContrato: false,

            pickerOptionsDataContrato: {
                disabledDate: date => date > new Date()
            }
        };
    },
    computed: {
        ...mapGetters(['isAlvorada'])
    },
    mounted() {
        this.buscarCulturas();
        this.buscarSafras();
        this.buscarFornecedores();
        // this.buscarEstados();
        this.buscarLocalidadeNivelUm();
        this.buscarClientes();
        this.buscarCamposNaoAtribuidos();
    },

    methods: {
        async buscarCulturas() {
            try {
                this.loading.culturas = true;
                const { data } =
                    await ContratoOriginacaoService.buscarCulturas();

                this.opcoes.culturas = data;
                this.loading.culturas = false;
            } catch (error) {
                this.$notify.error('Ocorreu um erro ao buscar as culturas');
            }
        },

        async buscarSafras() {
            try {
                this.loading.safras = true;
                const { data } = await ContratoOriginacaoService.buscarSafras();

                this.opcoes.safras = data;
                this.loading.safras = false;
            } catch (error) {
                this.$notify.error('Ocorreu um erro ao buscar as safras');
            }
        },

        async buscarFornecedores() {
            try {
                this.loading.fornecedor = true;
                const { data } =
                    await ContratoOriginacaoService.buscarBpClientes();

                this.opcoes.fornecedores = data;
                this.loading.fornecedor = false;
            } catch (error) {
                this.$notify.error('Ocorreu um erro ao buscar os fornecedores');
            }
        },

        async buscarEstados() {
            try {
                this.loading.estados = true;
                const { data } = await LocalidadeService.findEstados(false);

                this.opcoes.estados = data;
                this.loading.estados = false;
            } catch (error) {
                this.$notify.error('Ocorreu um erro ao buscar os estados.');
            }
        },

        async buscarMunicipios() {
            this.formCadastroManual.municipio = '';

            if (!this.formCadastroManual.estado) return;

            try {
                this.loading.municipios = true;
                const { data } =
                    await LocalidadeService.buscarLocalidadeNivelUm(
                        this.formCadastroManual.estado,
                        false
                    );

                this.opcoes.municipios = data;
                this.loading.municipios = false;
            } catch (error) {
                this.$notify.error('Ocorreu um erro ao buscar os municipios.');
            }
        },

        async buscarLocalidadeNivelUm() {
            try {
                this.loading.estados = true;
                const { data } =
                    await LocalidadeService.buscarLocalidadeNivelUm();
                this.opcoes.estados = data;
                this.loading.estados = false;
            } catch {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarEstados'
                    )
                );
            }
        },

        async buscarLocalidadeNivelDois() {
            this.formCadastroManual.municipio = '';

            if (!this.formCadastroManual.estado) return;

            try {
                this.loading.municipios = true;
                const { data } =
                    await LocalidadeService.buscarLocalidadeNivelDois(
                        this.formCadastroManual.estado,
                        false
                    );

                this.opcoes.municipios = data;
                this.loading.municipios = false;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarMunicipios'
                    )
                );
            }
        },

        async buscarClientes() {
            try {
                this.loading.clientes = true;
                const { data } =
                    await ContratoOriginacaoService.buscarClientes();

                this.opcoes.clientes = data;
                this.loading.clientes = false;
            } catch (error) {
                this.$notify.error('Ocorreu um erro ao buscar os clientes.');
            }
        },

        async definirCnpjFornecedor() {
            if (this.formCadastroManual.fornecedor) {
                this.formCadastroManual.cnpjFornecedor =
                    this.formCadastroManual.fornecedor.cpfCnpj[0];
            }
        },

        definirClienteDocumento() {
            this.formCadastroManual.clienteDocumento = '';
        },

        async buscarCamposNaoAtribuidos() {
            try {
                const { data } =
                    await ContratoOriginacaoServiceEmpresa.buscarCamposNaoAtribuidos();

                this.opcoes.camposNaoAtribuidos = data;
            } catch (error) {
                this.$notify.error(
                    'Ocorreu um erro ao buscar os campos não atribuídos.'
                );
            }
        },

        adicionar() {
            this.$refs['formCadastroManualRef'].validate(valid => {
                if (valid) {
                    this.adicionandoContrato = true;
                    ContratoOriginacaoServiceEmpresa.cadastrarManualmente({
                        numeroContrato: this.formCadastroManual.numeroContrato,
                        idMaterial: this.formCadastroManual.cultura,
                        idSafra: this.formCadastroManual.safra,
                        volumeContratado: parseFloat(
                            this.formCadastroManual.volumeContratado.replace(
                                ',',
                                '.'
                            )
                        ),
                        valorDataContrato:
                            this.formCadastroManual.dataContrato.getTime(),
                        idBpCliente: this.formCadastroManual.fornecedor.id,
                        idSubEmpresa:
                            this.formCadastroManual.fornecedor.idEmpresa,
                        subEmpresaCnpj: this.formCadastroManual.cnpjFornecedor,
                        idSegmento: this.opcoes.camposNaoAtribuidos.idSegmento,
                        idCanal: this.opcoes.camposNaoAtribuidos.idCanal,
                        idRegional: this.opcoes.camposNaoAtribuidos.idRegional,
                        idLocalidade: this.formCadastroManual.municipio,
                        idGerenteComercial:
                            this.opcoes.camposNaoAtribuidos.idPessoa,
                        idGestorTerritorial:
                            this.opcoes.camposNaoAtribuidos.idPessoa,
                        idGerenteRegional:
                            this.opcoes.camposNaoAtribuidos.idPessoa,
                        idClienteDocumento:
                            this.formCadastroManual.clienteDocumento,
                        valorContrato: 0,
                        condicaoFrete: 'Não atribuído',
                        localCondicaoFrete: 'Não atribuído',
                        tipoContratoOffline: false,
                        codigoExterno: this.formCadastroManual.codigoExterno
                    })
                        .then(() => {
                            this.$notify.success(
                                `Contrato ${this.formCadastroManual.numeroContrato} inserido`
                            );

                            this.$emit('contrato-inserido');
                            this.limpar();
                        })
                        .catch(erro => {
                            this.$notify.error({
                                message: erro.response.data.message
                            });
                        })
                        .finally(() => (this.adicionandoContrato = false));
                } else {
                    this.$notify.warning(
                        'Todos os campos precisam estar preenchidos.'
                    );
                    return false;
                }
            });
        },

        limpar() {
            this.$refs['formCadastroManualRef'].resetFields();
        }
    }
};
</script>

<style lang="scss">
#empresa-bloco-inserir-contrato-originacao-manualmente {
    .el-icon-arrow-right:before {
        content: '\E7A0';
        font-size: 24px;
        padding: 10px;
        color: var(--primary);
    }

    .el-card {
        border: none;
    }

    .el-form-item {
        padding: 0 4px;
    }

    .el-select,
    .el-input,
    .el-date-picker,
    .el-button {
        width: 100%;
    }

    .row {
        align-items: flex-end;
        margin-bottom: 15px;
    }

    .row.row-btn-adicionar {
        justify-content: space-between;
    }

    .el-form-item.is-required:not(.is-no-asterisk)
        > .el-form-item__label::before,
    .el-form-item.is-required:not(.is-no-asterisk)
        .el-form-item__label-wrap
        > .el-form-item__label:before {
        content: none !important;
        margin-right: 0px !important;
    }

    .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:after,
    .el-form-item.is-required:not(.is-no-asterisk)
        .el-form-item__label-wrap
        > .el-form-item__label:after {
        content: '*';
        color: #f56c6c;
        margin-left: 4px;
    }

    @media screen and (max-width: 1366px) {
        .el-form-item__label {
            font-size: 13px;
        }
    }

    @media screen and (max-width: 1280px) {
        .el-form-item__label {
            font-size: 12px;
        }
    }
}
</style>
